import { proxy } from "valtio";

type StoreType = {
    numberActive: number;
    numberArchived: number;
    isEdited: boolean;
    isPlusIconClicked: boolean;
    selectedApplicationSco: Record<string, string>[];
    isModalAssociateStore: boolean;
    isModalDissociateOpened: boolean;
    modify: boolean;
};

export const store = proxy<StoreType>({
    numberActive: 0,
    numberArchived: 0,
    isEdited: false,
    isPlusIconClicked: false,
    selectedApplicationSco: [],
    isModalAssociateStore: false,
    isModalDissociateOpened: false,
    modify: false,
});

export function setModify(modify: boolean): void {
    store.modify = modify;
}
export function setNumberActive(numberActive: number): void {
    store.numberActive = numberActive;
}
export function setIsModalAssociateStore(isModalAssociateStore: boolean): void {
    store.isModalAssociateStore = isModalAssociateStore;
}
export function setIsModalDissociateOpened(
    isModalDissociateOpened: boolean
): void {
    store.isModalDissociateOpened = isModalDissociateOpened;
}
export function setNumberArchived(numberArchived: number): void {
    store.numberArchived = numberArchived;
}
export function setIsEdited(isEdited: boolean): void {
    store.isEdited = isEdited;
}
export function setIsPlusIconClicked(isPlusIconClicked: boolean): void {
    store.isPlusIconClicked = isPlusIconClicked;
}
export function setSelectedApplicationSco(
    selectedApplicationSco: Record<string, string>[]
): void {
    store.selectedApplicationSco = selectedApplicationSco;
}

export default store;
